export default __webpack_public_path__ + "5fb49c6b900babbeecd39c2a94fa2f80.png";